import { useState } from "react";
import { Check } from "@phosphor-icons/react";
import confetti from "canvas-confetti";

const C = { ink: "var(--pr-ink)", ink2: "var(--pr-ink2)", muted: "var(--pr-muted)", line: "var(--pr-line)", gold: "var(--pr-gold)", green: "var(--pr-green)", bg: "var(--pr-bg)" };

export const PayoutChecklist = ({ items, dateKey }) => {
  const storageKey = `caddy.payout.${dateKey}`;
  const [done, setDone] = useState(() => {
    try { return new Set(JSON.parse(localStorage.getItem(storageKey) || "[]")); } catch { return new Set(); }
  });

  const toggle = (id) => {
    const next = new Set(done);
    if (next.has(id)) next.delete(id); else next.add(id);
    setDone(next);
    try { localStorage.setItem(storageKey, JSON.stringify([...next])); } catch { /* noop */ }
    if (next.size === items.length && !done.has(id)) {
      confetti({ particleCount: 100, spread: 70, origin: { y: 0.5 }, colors: ["#F5CB5C", "#3E8E4E", "#2A1E5C"] });
    }
  };

  const allDone = done.size === items.length;

  return (
    <div className="rounded-2xl p-5 lg:p-6 pr-card" data-testid="caddy-payout-checklist">
      <p className="text-[10px] font-bold uppercase tracking-widest mb-0.5" style={{ color: "var(--pr-accent-gold-text)" }}>🏆 Payout day</p>
      <p className="text-sm font-bold mb-1" style={{ color: C.ink }}>
        {allDone ? "Payout flow complete 🏁" : "Money has lanes, move it in order"}
      </p>
      <p className="text-[11px] mb-3" style={{ color: C.muted }} data-testid="payout-progress">
        {done.size} of {items.length} moved
      </p>
      <div className="space-y-1.5">
        {items.map((it, i) => {
          const checked = done.has(it.id);
          return (
            <button
              key={it.id}
              type="button"
              onClick={() => toggle(it.id)}
              className="w-full flex items-center gap-3 text-left px-3 py-3 rounded-xl transition-colors"
              style={{ background: checked ? "#EDF7EE" : C.bg }}
              data-testid={`payout-step-${it.id}`}
            >
              <span
                className="w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0"
                style={{ borderColor: checked ? C.green : C.line, background: checked ? C.green : "#fff" }}
              >
                {checked && <Check className="w-4 h-4 text-white" />}
              </span>
              <span
                className="text-sm leading-snug"
                style={{ color: checked ? C.muted : C.ink, textDecoration: checked ? "line-through" : "none", fontWeight: checked ? 400 : 600 }}
              >
                <span className="mr-1.5 text-xs font-bold" style={{ color: C.muted }}>{i + 1}.</span>
                {it.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
